import React from 'react';

const Description = () => {
    return (
        <div className='container'>
            <h1 className='fw-bold mt-5 pt-5'>WHERE PHOTOGRAPHY IS ABOUT <br /> MORE THAN PHOTOS</h1>
            <p>Wedding photography isn't just about creating flattering photos.

                It's about creating images that make you feel​​​​​​​ something. Documenting you and your family's story. And helping you eliminate fear, create a genuine connection, and become fulfilled in who you are - and
                who you're becoming as a married couple.</p>
        </div>
    );
};

export default Description;